import { MODE_3D_VIEW, MODE_DRAGGING_ITEM } from '@constants'
import { ThreeEvent } from '@react-three/fiber'
import { useAppStore } from '@store'
import { generateSceneLight } from '@utils/sceneObjects/lights/generateSceneLight'

type Props = {
  id: string
  catalogID: string | number
}

export function LightMesh3D({ id, catalogID }: Props) {
  const select = useAppStore.use.select()
  const unselect = useAppStore.use.unselectAll()
  const mode = useAppStore.use.mode()
  const setMode = useAppStore.use.setMode()
  const isSelected = useAppStore((store) => store.layers[store.currentLayer].selected.has(id))
  const preGLB = useAppStore.use.sceneGLB().get(catalogID)
  const isModalOpen = useAppStore.use.isModalOpen()
  function handleClick(e: ThreeEvent<MouseEvent>) {
    if (isModalOpen) return
    e.stopPropagation()

    if (isSelected) void unselect()

    if (!isSelected && mode === MODE_3D_VIEW) {
      select(id, false)
    }

    if (mode === MODE_DRAGGING_ITEM) {
      // setMode('MODE_IDLE')
    }
  }
  return (
    <group
      key={`${id}-mesh`}
      scale={1000}
      onClick={handleClick}
      castShadow={false}
      receiveShadow={false}
    >
      {generateSceneLight(preGLB?.glb.scene, isSelected)}
    </group>
  )
}
